import React from 'react';
import { useTranslation } from 'react-i18next';
import styles from './reservedCapacity.module.scss';
import RenderWrapper from 'features/shared/components/renderWrapper/RenderWrapper';

interface Props {
  requirementView?: boolean;
  showUnit?: boolean;
}

const ReservedCapacityElectricityHeader = ({ requirementView, showUnit }: Props) => {
  // translations
  const tLabels = useTranslation("contracts\\contracts").t;

  // sub-renders
  const renderLastColTitle = () => {
    if (requirementView) {
      return <>{tLabels("reservedCapacityElectricityHeader.newMonthly")} <span className="d-none d-xl-inline">{tLabels("reservedCapacityElectricityHeader.capacity")}</span></>
    } else {
      return <>{tLabels("reservedCapacityElectricityHeader.total")}</>
    }
  }

  const renderUnit = () => {
    if (showUnit) {
      return <small>[MW]</small>;
    }    
  }

  const renderTypeCol = () => {
    if (!requirementView) {
      return (
        <div className={`col-sm-auto text-right ${styles.typeCol}`}>
          {tLabels("reservedCapacityElectricityHeader.state")}
        </div>
      );
    }
  }

  const render15Mincol = () => { 
    return (
      <div className="d-none d-lg-block col text-center">
        {tLabels("reservedCapacityElectricityHeader.maxOf15Min")} {renderUnit()}
      </div>
    );
  }

  // render
  return (
    <div className={`d-none d-sm-block mb-2 text-muted font-weight-bold${!requirementView ? " px-2 px-sm-3" : ""}`}>
      <div className="row no-gutters align-items-end">
        <div className={`col-sm-auto ${styles.periodCol} font-weight-bold`}>
          {tLabels("reservedCapacityElectricityHeader.timePeriod")} 
        </div>
        <div className="col-sm text-center">
          <span className="d-lg-none">{tLabels("reservedCapacityElectricityHeader.power")}</span>
          <span className="d-none d-lg-inline">{tLabels("reservedCapacityElectricityHeader.reservedPower")}</span> {renderUnit()}
        </div>
        <div className="col-sm text-center">
          {tLabels("reservedCapacityElectricityHeader.yearly")} <span className="d-none d-xl-inline"> {tLabels("reservedCapacityElectricityHeader.capacity")}</span> {renderUnit()}
        </div>
        <div className="col-sm text-center">
          {tLabels("reservedCapacityElectricityHeader.monthly")} <span className="d-none d-xl-inline"> {tLabels("reservedCapacityElectricityHeader.capacity")}</span> {renderUnit()}
        </div>
        <RenderWrapper isVisible={() => requirementView === true}>
          {render15Mincol()}
        </RenderWrapper>
        <div className={`col-sm text-${requirementView ? "right" : "center"}`}>
          {renderLastColTitle()} {renderUnit()}
        </div>
        <RenderWrapper isVisible={() => requirementView !== true}>
          {render15Mincol()}
        </RenderWrapper>
        {renderTypeCol()}
      </div>
    </div>
  )
}

export default ReservedCapacityElectricityHeader;
